import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Autocomplete, TextField, Box } from '@mui/material'
import MainCard from 'components/MainCard'
import React, { useState } from 'react'

function StorageUsage() {
    const [selectedPlan, setSelectedPlan] = useState(null);
   
    const allCoaches = [
        {
            poseId: 1,
            coachName: 'Coach-1',
            pose: 'pose-1',
            time: '15sec'
            
        },
        
        {
             poseId: 2,
            coachName: 'Coach-2',
            pose: 'pose-4',
            time: '8sec'
        },
        {
            poseId: 3,
            coachName: 'Coach-3',
            pose: 'pose-15',
            time: '10sec'
        },
        {
            poseId: 4,
            coachName: 'Coach-4',
             pose: 'pose-22',
            time: '15sec'
        },
       
    ];
    const filteredCoaches = selectedPlan
        ? allCoaches.filter((coach) => coach.plan === selectedPlan)
        : allCoaches;
  return (
    <MainCard>
      {/* <Box sx={{ mb: 2, maxWidth: 300 }}>
        <Autocomplete
          options={planOptions}
          value={selectedPlan}
          onChange={(event, newValue) => setSelectedPlan(newValue)}
          renderInput={(params) => <TextField {...params} label="Filter by Plan" variant="outlined" />}
          clearOnEscape
          isOptionEqualToValue={(option, value) => option === value}
        />
      </Box> */}
      <TableContainer component={Paper}>
                <Table sx={{ minWidth: 800 }} aria-label="coach table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Coach Name</TableCell>
                      <TableCell>Pose Name</TableCell>
                      <TableCell>Responce Time</TableCell>                                 
                    </TableRow>
                  </TableHead>
                 <TableBody>
                    {filteredCoaches.length > 0 ? (
                      filteredCoaches.map((coach, index) => (
                        <TableRow key={coach.poseId}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>
                            {coach.coachName
                              .toLowerCase()
                              .split(' ')
                              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                              .join(' ')}
                          </TableCell>                        
                          <TableCell>{coach.pose}</TableCell>
                          <TableCell>{coach.time}</TableCell>
                          
                             
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                          <Lottie options={loaderOptions} height="25%" width="25%" />
                          <Box sx={{ mt: 2 }}>No coaches found matching your criteria.</Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody> 
                </Table>
              </TableContainer>
    </MainCard>
  )
}

export default StorageUsage;